module.exports = __webpack_public_path__ + "img/SWP_Shield_05 (2).c06ae8c5.png";